import styled from "styled-components";

export const ItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: 1.25rem;
`
